import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VapService} from '../../../services/vap.service';
import {Question} from '../../../models/underwriter.model';
import { GlobalQuestionService } from '../../../services/global-question.service';

@Component({
    selector: 'app-vaps-mini-flow-player',
    templateUrl: './vaps-mini-flow-player.component.html',
    styleUrls: ['./vaps-mini-flow-player.component.scss'],
    standalone: false
})
export class VapsMiniFlowPlayerComponent implements OnInit {

  @Input() lastItemId = '';
  @Input() editItemId = '';
  @Input() vapId: number;
  @Input() classId: number;
  @Input() flowId: number;
  @Input() productId: number;
  @Output() lastItemIdChange = new EventEmitter<any>();
  @Output() flowComplete = new EventEmitter<any>();

  questions: Question[] = [];
  activeQuestion: Question;
  showPlayer = false;
  showAddAnother = true;
  buttonDisabled = true;
  percentage = 0;
  class_item_id = '';
  item_id = '';

  constructor(private vapService: VapService, private questionService: GlobalQuestionService) {
  }

  ngOnInit(): void {
    console.log('edit item id', this.editItemId);
    console.log('last item id', this.lastItemId);
    if ((this.editItemId || +this.lastItemId === 0) && this.vapId && this.classId >= 0) {
      this.showAddAnother = false;
      this.showPlayer = true;
      if (!this.editItemId) {
        this.item_id = (+this.lastItemId + 1).toString();
      } else {
        this.item_id = this.editItemId;
      }
      this.loadFlowPlayer();
    } else if (!this.editItemId && +this.lastItemId > 0 && this.vapId && this.classId >= 0) {
      this.showAddAnother = true;
      this.showPlayer = false;
    }
  }

  // getFlowQuestions returns the flow's full question set (not just newly-unlocked ones),
  // so blindly pushing its results duplicates every question already in this.questions -
  // those duplicates never get an answer, which permanently blocks the
  // "every question answered" check in submitFlowComplete() and stalls the progress bar
  mergeNewQuestions(questions: Question[]): void {
    for (const question of questions || []) {
      if (!this.questions.some(q => q?.cent_aq_question_id === question?.cent_aq_question_id)) {
        this.questions.push(question);
      }
    }
  }

  loadFlowPlayer(): void {
    if (this.showPlayer) {
      this.vapService.getFlowQuestions(this.vapId, this.flowId, this.item_id)
        .subscribe({
          next: questions => {
            this.questions = questions;
            console.log('questions', this.questions);
            this.activeQuestion = JSON.parse(JSON.stringify(this.questions[0]));
            if (this.activeQuestion?.answer) {
              this.buttonDisabled = false;
            }
            this.percentage = 0;
            $('#question-add-container').animate({height: 'toggle', opacity: 'toggle'}, 200, () => {
              $('#question-container').slideDown(300);
            });
          }
        });
    }
  }

  addAnother(): void {
    this.showAddAnother = false;
    this.showPlayer = true;
    this.item_id = (+this.lastItemId + 1).toString();
    this.loadFlowPlayer();
  }

  removeBenefit(): void {
    this.vapService.removeBenefit(this.classId, this.vapId, this.item_id)
      .subscribe({
        next: () => {
          this.flowComplete.emit(true);
        }
      });
  }

  onAnswerChange(question: Question): void {
    
    if (question?.answer) {
      this.activeQuestion = question;
      for (const q of this.questions) {
        if (q?.cent_aq_question_id === this.activeQuestion?.cent_aq_question_id) {
          q.answer = this.activeQuestion?.answer;
          q.answer_id = this.activeQuestion?.answer_id;
        }
      }
      if (this.activeQuestion?.options) {
        const options = JSON.parse(this.activeQuestion?.options);
        if (options?.length) {
          for (const o of options) {
            if (o.hasOwnProperty('cent_aq_answer_id') && o?.cent_aq_answer_id?.toString() === this.activeQuestion?.answer_id.toString()) {
              if (o.hasOwnProperty('item_id') && o?.item_id) {
                this.item_id = o?.item_id.toString();
              }
            }
          }
        }
      }
      this.buttonDisabled = false;
    } else {
      if (!this.activeQuestion?.answer) {
        this.buttonDisabled = true;
      }
    }
  }

  saveAnswer(): void {
    // the Next link is an <a>, so [attr.disabled] doesn't actually block clicks -
    // guard here instead, otherwise a click while unanswered (or after activeQuestion
    // goes null between conditional-flow steps) posts a request with no question_id
    if (this.buttonDisabled || !this.activeQuestion?.cent_aq_question_id) {
      return;
    }
    this.vapService.saveAnswer(this.activeQuestion, this.classId, this.item_id, this.flowId, this.vapId)
      .subscribe({
        next: () => {
          if (this.activeQuestion?.call_proc) {
            const proc = this.vapService.replaceCallProcParameters(this.activeQuestion?.call_proc, this.item_id, this.classId, this.activeQuestion?.cent_aq_question_id, this.flowId, this.vapId);
            this.vapService.runCommand(proc)
              .subscribe({
                next: (p: any[]) => {
                  if (p?.length && p[0]?.next) {
                    this.vapService.getFlowQuestions(this.vapId, this.flowId, this.item_id)
                      .subscribe({
                        next: (questions: any[]) => {
                          if (questions?.length) {
                            this.mergeNewQuestions(questions);
                            const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                            this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === p[0]?.next);
                            this.activeQuestion.previous = currentQuestionId;
                            this.buttonDisabled = !this.activeQuestion?.answer;
                            this.submitFlowComplete();
                            this.getPercentage();
                          }
                        }
                      });
                  } else {
                    if (this.activeQuestion?.conditions?.length) {
                      this.vapService.getNext(this.item_id, this.activeQuestion?.cent_aq_question_id, this.flowId)
                        .subscribe({
                          next: (n: any[]) => {
                            if (n?.length && n[0]?.next) {
                              this.vapService.getFlowQuestions(this.vapId, this.flowId, this.item_id)
                                .subscribe({
                                  next: (questions: any[]) => {
                                    if (questions?.length) {
                                      this.mergeNewQuestions(questions);
                                      const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                                      this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === n[0]?.next);
                                      this.activeQuestion.previous = currentQuestionId;
                                      this.buttonDisabled = !this.activeQuestion?.answer;
                                      this.submitFlowComplete();
                                      this.getPercentage();
                                    }
                                  }
                                });
                            } else {
                              if (this.activeQuestion?.next) {
                                const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                                this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === this.activeQuestion?.next);
                                this.activeQuestion.previous = currentQuestionId;
                                this.buttonDisabled = !this.activeQuestion?.answer;
                              } else {
                                this.activeQuestion = null;
                              }
                              this.submitFlowComplete();
                              this.getPercentage();
                            }
                          }
                        });
                    } else {
                      if (this.activeQuestion?.next) {
                        const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                        this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === this.activeQuestion?.next);
                        this.activeQuestion.previous = currentQuestionId;
                        this.buttonDisabled = !this.activeQuestion?.answer;
                      } else {
                        this.activeQuestion = null;
                      }
                      this.submitFlowComplete();
                      this.getPercentage();
                    }
                  }
                }
              });
          } else {
            if (this.activeQuestion?.conditions?.length) {
              this.vapService.getNext(this.item_id, this.activeQuestion?.cent_aq_question_id, this.flowId)
                .subscribe({
                  next: (n: any[]) => {
                    if (n?.length && n[0]?.next) {
                      this.vapService.getFlowQuestions(this.vapId, this.flowId, this.item_id)
                        .subscribe({
                          next: (questions: any[]) => {
                            if (questions?.length) {
                              this.mergeNewQuestions(questions);
                              const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                              this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === n[0]?.next);
                              this.activeQuestion.previous = currentQuestionId;
                              this.buttonDisabled = !this.activeQuestion?.answer;
                              this.submitFlowComplete();
                              this.getPercentage();
                            }
                          }
                        });
                    } else {
                      if (this.activeQuestion?.next) {
                        const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                        this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === this.activeQuestion?.next);
                        this.activeQuestion.previous = currentQuestionId;
                        this.buttonDisabled = !this.activeQuestion?.answer;
                      } else {
                        this.activeQuestion = null;
                      }
                      this.submitFlowComplete();
                      this.getPercentage();
                    }
                  }
                });
            } else {
              if (this.activeQuestion?.next) {
                const currentQuestionId = this.activeQuestion?.cent_aq_question_id;
                this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === this.activeQuestion?.next);
                this.activeQuestion.previous = currentQuestionId;
                this.buttonDisabled = !this.activeQuestion?.answer;
                console.log('answer', this.activeQuestion)
              } else {
                this.activeQuestion = null;
              }
              this.submitFlowComplete();
              this.getPercentage();
            }
          }
        }
      });
  }

  submitFlowComplete(): void {
    if (this.questions.every(q => q?.answer) && !this.activeQuestion) {
      this.questionService.spinner(true);
      this.vapService.calcPremiumAddons(this.vapId, this.item_id, this.productId)
        .subscribe({
          next: () => {
            this.flowComplete.emit(true);
            this.emitLastItemId();
            this.showPlayer = false;
            this.showAddAnother = true;
            setTimeout(() => {
              this.questionService.spinner(false);
            }, 2000);
            
          }
        });
    }
  }

  goToPrevious(): void {
    const previousId = this.activeQuestion?.previous;
    this.activeQuestion = this.questions?.find(q => q?.cent_aq_question_id === previousId);
    if (this.activeQuestion?.answer) {
      this.buttonDisabled = false;
    }
  }

  getPercentage(): void {
    const answeredQuestionsLength = this.questions?.filter(q => q?.answer)?.length;
    this.percentage = +((answeredQuestionsLength / this.questions?.length) * 100).toFixed(2);
    console.log('percentage', this.percentage);
  }

  emitLastItemId(): void {
    if (!this.editItemId && (+this.lastItemId + 1 === +this.item_id)) {
      this.lastItemId = (+this.lastItemId + 1).toString();
      this.lastItemIdChange.emit(this.lastItemId);
    }
  }

}
